import { ViewSettingsModal } from './view-settings-modal';

import { TableView } from '../types';

export const EditViewSettingsModal = ({
  view,
  updateView,
  isLastCollaborative = false,
}: {
  view: TableView;
  updateView: (updatedView: TableView) => void;
  isLastCollaborative?: boolean;
}) => (
  <ViewSettingsModal
    defaultName={view.name ?? ''}
    defaultIsCollaborative={view.isCollaborative !== false}
    isLastCollaborative={isLastCollaborative}
    onSave={(name, isCollaborative) => updateView({ ...view, name, isCollaborative })}
  />
);
